const badgesList = [
  {
    key: 'actif',
    label: 'Recruteur Actif',
    stars: '★',
    description: "Premier niveau pour les recruteurs actifs sur la plateforme."
  },
  {
    key: 'confirme',
    label: 'Recruteur Confirmé',
    stars: '★★',
    description: "Attribué aux recruteurs avec plusieurs talents qualifiés."
  },
  {
    key: 'aguerri',
    label: 'Recruteur Aguerri',
    stars: '★★★',
    description: "Attribué aux recruteurs réguliers avec des profils proposés."
  },
  {
    key: 'expert',
    label: 'Recruteur Expert',
    stars: '★★★★',
    description: "Reconnaissance pour un volume et une qualité de sourcing élevés."
  },
  {
    key: 'ambassadeur',
    label: 'Recruteur Ambassadeur',
    stars: '★★★★★',
    description: "Top badge réservé aux meilleurs recruteurs de la plateforme."
  }
];

export default badgesList;
